import { useTenantContext } from '../contexts/TenantContext'

/**
 * Hook for accessing tenant/organization context.
 * 
 * @example
 * const { organization, profile, isLoading } = useTenant()
 */
export function useTenant() {
  return useTenantContext()
}
